module.exports = __webpack_public_path__ + "img/icon_overtime_2.23e5836b.svg";